export default __webpack_public_path__ + "static/media/27.fbe5e784.jpg";